import { FormControlLabel, formControlClasses } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "SwitchFormControlLabel";
export const classes = {
  root: `${PREFIX}-root`,
};

export const SwitchFormControlLabel = styled(FormControlLabel)(() => ({
  [`&.${classes.root}`]: {
    justifyContent: "space-between",
    [`&.${formControlClasses.root}`]: {
      margin: 0,
    },
  },
}));
